import { Box } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../redux/store";
import { setLoadingAction } from "../../../../redux/utils/actions";
import { logger } from "../../../../utils/logger";
import DepartmentFormStepOne from "./Steps/DepartmentFormStepOne";
import departmentService from "../../../../services/department";

const AddDepartmentForm = ({ steps }: { steps: number }) => {
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();

  const { id } = useParams();
  const dispatch = useAppDispatch();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "role" && values?.town) {
      setFieldValue("town", null);
    }
    setFieldValue(e.target.name, e.target.value, true);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        if (id) {
          dispatch(setLoadingAction(true));
          const res = await departmentService.getById(id);
          dispatch(setLoadingAction(false));

          const formValues = {
            ...res.data.data,
            name: res.data.data.name,
            expiresOn: res.data.data.expiresOn,
            expiresIn: res.data.data.expiresIn,
            maxAmount: res.data.data.maxAmount,
          };
          setValues(formValues);
        }
      } catch (error: any) {
        dispatch(setLoadingAction(false));
        logger.error(error);
      }
    };
    if (id) {
      getData();
    }
  }, [dispatch, id, setValues]);

  return (
    <div>
      <Box>
        {steps === 0 && <DepartmentFormStepOne inputHandler={inputHandler} />}
      </Box>
    </div>
  );
};

export default AddDepartmentForm;
